var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-container",style:(_vm.getStyle)},[_c('div',{staticClass:"value-box"},[_vm._v(" "+_vm._s(_vm.valueLabel)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }